<template>
  <div class="version1-left-bottom">
    <Header :title="title"></Header>
    <div class="totalBar-content">
      <swiper ref="mySwiper" :options="swiperOptions" @mouseenter="stopAutoplayAnimation" @mouseleave="reStartAnimation"
        v-if="patentList.length > 0">
        <swiper-slide v-for="(item, index) in patentList" :key="index">
          <div class="item" @click="detailClick(item)">
            <div class="content-number">
              <span class="top">TOP.{{ index + 1 }}</span>
              <img src="../../../../../static/version1/学院专利箭头.png" alt="">
              <span class="name">{{ item.name }}</span>
            </div>
            <div class="progress-block">
              <div class="progress">
                <a-progress :stroke-color="{
                  from: '#0071FC',
                  to: '#4BE2EC',
                }" :percent="item.ratio" size="small" :showInfo="false" />

                <img src="../../../../../static/version1/学院专利光点.png" alt="" :style="style(item.ratio)">
              </div>
              <span class="count">{{ item.count }}</span>
            </div>

          </div>
        </swiper-slide>
      </swiper>
      <img src="../../../../../static/nodata2.png" alt="" v-else class="no-data">
    </div>
  </div>
</template>

<script>
import { getPatentAll, ipcsecRange, seiRange } from '@/api/databaseBin'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import BaseMixin from '@/views/_mixin'
import Header from './header.vue'
import { getStorage } from '@/utils'
import { mapState } from 'vuex'

export default {
  mixins: [BaseMixin],
  created() {
    this.initData()
  },
  data() {
    return {
      patentList: [],
      swiperOptions: {
        init: false,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false // 触碰后自动轮播也不会停止
        },
        height: 280,
        spaceBetween: 5, // 板块间隔
        slidesPerView: 5, // 页面中的板块数量
        direction: 'vertical',
        observer: true,
        observeParents: true,
        loop: false // 首尾循环
      }
    }
  },
  methods: {
    detailClick(item) {
      // this.gov = true,字段叫 ipc_section_stat 否则 org_name_stat
      if (this.isGov) {
        if (this.useNewGovTemplate) {
          this.jumpIpi(`战略性新兴产业分类=(${item.classCode}) and 专利类型=(发明授权 or 实用新型 or 外观设计)`)
        } else {
          this.jumpIpi('ipc_section_stat=' + item.classCode)
        }
      } else {
        this.jumpIpi('org_name_stat=' + item.name)
      }
    },
    style(v) {
      return { left: v - 6 + '%' }
    },
    async initData() {
      let result = null
      if (this.isGov) {
        const govRange = this.useNewGovTemplate ? seiRange : ipcsecRange
        result = await govRange()
        if (result.code === 200) {
          result.data.forEach(item => {
            item.name = item.classCode + ' ' + item.classCnName
          })
        }
      } else {
        result = await getPatentAll()
      }
      this.patentList = result[this.dataMapping]
      const data = this.patentList.sort(function (a, b) {
        return b.count - a.count
      })
      const maxcount = data[0].count
      this.patentList.forEach((element) => {
        element.ratio = (element.count / maxcount).toFixed(2) * 100
      })
      this.$forceUpdate()
      this.$nextTick(() => {
        this.swiper.init()
      })
    },
    stopAutoplayAnimation() {
      this.swiper.autoplay.stop()
    },
    reStartAnimation() {
      this.swiper.autoplay.start()
    }
  },
  components: {
    swiper,
    swiperSlide,
    Header
  },
  computed: {
    ...mapState('title', ['title']),
    ...mapState('user', ['useNewGovTemplate']),
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    isGov() {
      return getStorage('tenantType', 0) === 'government'
    }
  }
}
</script>
